module.exports = __webpack_public_path__ + "static/media/player-turn.a673b70c.wav";